// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3jdQu","col":"styles_col__1jOzc"};